import { face_surface } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class advanced_face extends face_surface {
    get type() {
        return EntityTypesAP214.ADVANCED_FACE;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
advanced_face.query = [EntityTypesAP214.ADVANCED_FACE];
advanced_face.expectedType = EntityTypesAP214.ADVANCED_FACE;
